/** A plain YYYY-MM-DD is a local calendar day; new Date('YYYY-MM-DD') would read it as UTC midnight. */
function parseDay(iso: string): Date {
	return /^\d{4}-\d{2}-\d{2}$/.test(iso) ? new Date(`${iso}T00:00:00`) : new Date(iso);
}

/** YYYY-MM-DD for a Date, in local time. */
export function toIsoDate(d: Date): string {
	return d.toLocaleDateString('en-CA');
}

/** "today", "yesterday", "3d ago", or the date (YYYY-MM-DD) for anything older than a month. */
export function relativeDay(iso: string | null | undefined): string {
	if (!iso) return '';
	const d = parseDay(iso);
	const today = new Date();
	today.setHours(0, 0, 0, 0);
	const day = new Date(d);
	day.setHours(0, 0, 0, 0);
	const diff = Math.round((today.getTime() - day.getTime()) / 86_400_000);
	if (diff <= 0) return 'today';
	if (diff === 1) return 'yesterday';
	if (diff < 30) return `${diff}d ago`;
	return toIsoDate(d);
}

/** YYYY-MM-DD, or blank when there is no date. Accepts ISO timestamps and plain dates. */
export function formatDate(iso: string | null | undefined): string {
	if (!iso) return '';
	// plain "YYYY-MM-DD" must not shift by timezone
	if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso;
	return new Date(iso).toLocaleDateString('en-CA');
}

/** "2026-09-13 4:48 PM": date as used everywhere else, time without seconds. */
export function formatDateTime(iso: string | null | undefined): string {
	if (!iso) return '';
	const d = new Date(iso);
	return `${d.toLocaleDateString('en-CA')} ${d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}`;
}
